import { Routes } from '@angular/router';
import { MatchDetailComponent } from './match-detail/match-detail.component';
import { SportsbookHomeComponent } from './sportsbook-home/sportsbook-home.component';

export const routes: Routes = [
  {
    path: '',
    component: SportsbookHomeComponent
  },
  {
    path: 'tickets',
    loadComponent: () => import('./account-tickets/account-tickets.component').then(component => component.AccountTicketsComponent)
  },
  {
    path: 'transactions',
    loadComponent: () => import('./account-transactions/account-transactions.component').then(component => component.AccountTransactionsComponent)
  },
  {
    path: 'results',
    loadComponent: () => import('./account-results/account-results.component').then(component => component.AccountResultsComponent)
  },
  {
    path: 'match/:matchId',
    component: MatchDetailComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
